import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Calendar, MessageCircle, Sparkles } from 'lucide-react';
import { Toaster } from '../components/ui/toaster';

const CustomDesign = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-light text-gray-800 mb-4">Custom Design Services</h1>
          <p className="text-lg text-gray-600">
            Bring your dream jewelry to life with our custom design process
          </p>
        </div>
      </div>

      {/* Process */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-16">
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <MessageCircle size={32} className="text-gray-700" />
            </div>
            <h3 className="text-xl font-normal mb-3 text-gray-800">1. Consultation</h3>
            <p className="text-gray-600">
              Schedule a virtual or in-person consultation to discuss your vision, preferences, and budget.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Sparkles size={32} className="text-gray-700" />
            </div>
            <h3 className="text-xl font-normal mb-3 text-gray-800">2. Design & CAD</h3>
            <p className="text-gray-600">
              Our team creates detailed CAD renderings of your custom piece for your review and approval.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Calendar size={32} className="text-gray-700" />
            </div>
            <h3 className="text-xl font-normal mb-3 text-gray-800">3. Creation</h3>
            <p className="text-gray-600">
              Once approved, we begin crafting your custom piece with ethical materials and expert craftsmanship.
            </p>
          </div>
        </div>

        {/* Details */}
        <div className="bg-gray-50 rounded-lg p-8 mb-8">
          <h2 className="text-2xl font-light mb-6 text-gray-800">Custom Design Details</h2>
          <div className="space-y-4 text-gray-700">
            <p><strong>Timeline:</strong> 6-8 weeks from design approval to completion</p>
            <p><strong>CAD Deposit:</strong> $250 (credited toward your final purchase)</p>
            <p><strong>Materials:</strong> Lab-grown diamonds, recycled metals, ethically sourced gemstones</p>
            <p><strong>Modifications:</strong> Unlimited revisions during the CAD phase</p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button size="lg" className="bg-gray-900 hover:bg-gray-800 text-white px-8">
            Schedule Consultation
          </Button>
        </div>
      </div>

      <Footer />
      <Toaster />
    </div>
  );
};

export default CustomDesign;